import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './static/css/root.css';
import {IndexPage} from "./pages/index.page";
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import {NewsPage} from "./pages/news.page";
import {Article1Page} from "./pages/article1.page";

function Root() {
    return (
        <Router>
            <Routes>
                {/* Trasa główna */}
                <Route path="/" element={<IndexPage />} />
                <Route path="/news" element={<NewsPage />} />
                {/*<Route path="/news/article/:id" element={<ArticlePage />} />*/}
                <Route path="/news/article/1" element={<Article1Page />} />
            </Routes>
        </Router>
    );
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Root />
    </React.StrictMode>
);
